import React from 'react';
import { CHECKOUT_URL } from '../constants/checkout';
import { trackAddToCart } from '../utils/metaPixel';
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slateblue-100 bg-white/95 p-3 backdrop-blur md:hidden" data-id="element-57" data-mp="1p0ro7lw5casn">
      <a href={CHECKOUT_URL} rel="noopener" onClick={() => trackAddToCart()} className="flex w-full items-center justify-center gap-2 rounded-xl bg-coral px-4 py-3.5 text-center text-sm font-extrabold uppercase text-white shadow-lg transition-colors hover:bg-coral-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40" data-id="element-58" data-mp="1xzd1b1iumxm1">
        Comprar ahora por $6.39
      </a>
    </div>;
}